import { css } from "@emotion/react";
import { Link } from "react-router";
import { FlexRowContainer } from "../bits/layout";

interface HomeSectionHeaderProps {
  title: string;
  linkTo?: string;
  linkTitle?: string;
  className?: string;
}

export const HomeSectionHeader = ({
  title,
  linkTitle,
  linkTo,
  className,
}: HomeSectionHeaderProps) => {
  return (
    <FlexRowContainer
      className={className}
      css={css`
        width: 100%;
      `}
    >
      <h2
        css={({ colours, customTypography }) => css`
          color: ${colours.primary.mid.dark20};
          ${customTypography.jumbo._3}
          text-align: left;
        `}
      >
        {title}
      </h2>
      {linkTo && linkTitle && (
        <Link
          to={linkTo}
          css={({ colours, customTypography }) => css`
            color: ${colours.primary.mid.dark20};
            ${customTypography.label._1}
            text-align: right;
            line-height: 24px;
            text-decoration: underline;
          `}
        >
          {linkTitle}
        </Link>
      )}
    </FlexRowContainer>
  );
};
